import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sumCurrency'
})
export class SumCurrencyPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if(value === 0) return "0,00 €";
    else return parseFloat(value).toFixed(2).replace(".", ",") + " €";
  }

}
